<template>
  <div>
    <div style="display:none">
      <VueEditor></VueEditor>
    </div>
    <div class="ql-snow">
      <div class="ql-editor" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "TextEditorPreview",
  props: ["content"],
  components: {
    VueEditor
  }
};
</script>
